import React, { useState } from 'react';
import siteContent from '../data/siteContent';
import './Contact.css';

export default function Contact() {
  const { contact, company } = siteContent;
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    const res = await fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(data).toString(),
    });

    if (res.ok) {
      setSubmitted(true);
      form.reset();
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="section-inner">
        <div className="contact-grid">
          <div>
            <div className="section-label">{contact.sectionLabel}</div>
            <h2>{contact.heading}</h2>
            <p className="section-sub">{contact.subtext}</p>
            <div className="contact-info">
              <h3>Email</h3>
              <p><a href={`mailto:${company.email}`}>{company.email}</a></p>
              <h3>Website</h3>
              <p><a href={`https://${company.website}`}>{company.website}</a></p>
              <h3>Response Time</h3>
              <p>{company.responseTime}</p>
            </div>
          </div>
          <div>
            {submitted ? (
              <div className="form-success">
                <p>✓ Message received! We'll be in touch shortly.</p>
              </div>
            ) : (
              <form
                name="contact"
                method="POST"
                data-netlify="true"
                onSubmit={handleSubmit}
              >
                <input type="hidden" name="form-name" value="contact" />
                <div className="form-row">
                  <input type="text" name="name" placeholder="Your Name" required />
                  <input type="email" name="email" placeholder="Email Address" required />
                </div>
                <input type="text" name="company" placeholder="Company / Organization" />
                <select name="service" defaultValue="">
                  <option value="" disabled>Service of Interest</option>
                  {contact.serviceOptions.map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
                <textarea name="message" placeholder="Tell us about your project or inquiry..." />
                <button type="submit" className="btn-primary" style={{ width: '100%', textAlign: 'center' }}>
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
